import React from "react";
import { connect } from "react-redux";
import Component from "./component";
import { setFormData, nextStep, previousStep } from "../pickup-form.actions";
import { withRouter } from "react-router";

const mapStateToProps = (state, ownProps) => ({
  phoneNumber: state.donorWizard.formValues.phoneNumber,
  step: state.donorWizard.formValues.step,
});

const mapDispatchToProps = (dispatch) => ({
  addDonor: () =>
    dispatch(setFormData({ isNewDonor: true, skipRegistration: true })),
  previousStep: () => dispatch(previousStep()),
});

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(withConnect);
